/** Lazily created so construction does not run before a user gesture when possible. */
let ctxCache = null;

/**
 * Short two-tone chime for Socket.IO / toast notifications.
 * May stay silent until the user has interacted with the page (browser autoplay policy).
 */
export function playNotificationSound() {
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    if (!ctxCache) ctxCache = new AC();

    const ctx = ctxCache;
    const run = () => {
      const t0 = ctx.currentTime;
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "sine";
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.frequency.setValueAtTime(784, t0);
      osc.frequency.setValueAtTime(988, t0 + 0.08);
      gain.gain.setValueAtTime(0, t0);
      gain.gain.linearRampToValueAtTime(0.12, t0 + 0.02);
      gain.gain.linearRampToValueAtTime(0.1, t0 + 0.1);
      gain.gain.linearRampToValueAtTime(0, t0 + 0.22);
      osc.start(t0);
      osc.stop(t0 + 0.24);
    };

    if (ctx.state === "suspended") {
      ctx.resume().then(run).catch(() => {});
    } else {
      run();
    }
  } catch (_) {
    /* ignore */
  }
}
